import React from "react";
import { Form, Col, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import moment from "moment/min/moment-with-locales";

export default function DaysPicker({
    formData,
    setFormData,
    name,
    size = "sm",
    ColXl = "auto",
    fluid = false,
    readOnly = false,
    disabled = false,
    onlyInput = false,
}) {
    const input = (
        <ToggleButtonGroup
            className={`ra-toggle-picker ${fluid ? `fluid-${fluid}` : ""}`}
            type="checkbox"
            size={size}
            value={formData.days}
            onChange={value => (readOnly ? null : setFormData({ ...formData, days: value }))}>
            {Array.from({ length: 7 }, (_, i) => (
                <ToggleButton
                    key={i}
                    value={i}
                    disabled={disabled}
                    id={`${name}-days-selection-${i}`}
                    variant="ra-yellow-outline"
                    className={`${readOnly && "pe-none"}`}>
                    {moment()
                        .locale("en-gb")
                        .weekday(i)
                        .locale(window.navigator.userLanguage || window.navigator.language)
                        .format("ddd")}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );

    if (onlyInput) return input;

    return (
        <Form.Group as={Col} className={`col-12 col-xl-${ColXl}`} controlId={`${name}-days-picker`}>
            <Form.Label>Days</Form.Label>
            <br></br>
            {input}
        </Form.Group>
    );
}
